import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { DatepickerComponent } from "../../../../shared/components/form/index";
import { ToolFormModel, ToolFormLifecycle } from "../../tool-create.model";
import { Log } from "ng2-logger";
import { InputDurationComponent } from '@components/form';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-tool-lifecycle-form',
    templateUrl: 'tool-lifecycle-form.component.html',
    styleUrls: ['tool-lifecycle-form.component.scss']
})
export class ToolLifecycleFormComponent implements OnInit, OnChanges {
    _logger = Log.create(ToolLifecycleFormComponent.name);

    @ViewChildren(InputDurationComponent) inputDurationComponents: InputDurationComponent[];
    @ViewChild(DatepickerComponent, {static: true}) datePicker: DatepickerComponent;

    @Input() tool: ToolFormModel;
    @Input() showValidations = false;

    form: UntypedFormGroup;

    currentProductionTimeMultiplier = 1;

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
        this.form = new UntypedFormGroup({
            partNumbersCount: new UntypedFormControl(this.tool.partNumbersCount),
            currentProductionCycles: new UntypedFormControl(this.tool.currentProductionCycles),
            currentProductionTime: new UntypedFormControl(this.tool.currentProductionTime),
            expirationDate: new UntypedFormControl(this.tool.expirationDate),
            toolRevisionPercent: new UntypedFormControl(this.tool.toolRevisionPercent)
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["tool"] && this.form) {
            this.loadFormValues(this.tool)
        }
    }

    currentProductionTimeChanged(event: any) {
        this.currentProductionTimeMultiplier = event.multiplier;
    }

    public loadFormValues(tool: ToolFormModel) {
        const toolLifecycle = new ToolFormLifecycle();
        this.form.setValue({
            partNumbersCount: tool.partNumbersCount || toolLifecycle.partNumbersCount,
            currentProductionCycles: tool.currentProductionCycles || toolLifecycle.currentProductionCycles,
            currentProductionTime: this.tool.currentProductionTime || toolLifecycle.currentProductionTime,
            expirationDate: this.tool.expirationDate || toolLifecycle.expirationDate || 0,
            toolRevisionPercent: this.tool.toolRevisionPercent || toolLifecycle.toolRevisionPercent
        });
    }


    getFormValue() {
        return this.form.value;
    }

    get isFormValid() {
        return this.form.valid;
    }

    resetForm() {
        this._logger.info("resetForm:: with", this.tool);
        this.form.reset();
        this.inputDurationComponents.forEach(component => {
            component.resetTimeUnit();
        });
        this.form.controls.expirationDate.setValue(null);
    }

    get errorMessage() {
        return `At least one of ${this.translate.instant('admin.tools.details.detailsPage.labels.lifetimeEstimation')} or
        ${this.translate.instant('admin.tools.details.detailsPage.labels.lifecycleEstimation')} is required.`;
    }

}
